'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc service
 * @name $numberFormat
 * @function
 *
 * @description
 * Number formatter based on numeraljs.
 *
 */
ngModule.factory("$numberFormat", function (stringUtils) {
  /**
   *
   * @param nbDecimals le nombre de décimales a afficher. Si non fourni, alors c'est 2 décimales optionnelles en cas de 0
   * @param suffix optionnel
   * @param optionalZeroAtTheEnd si true, alors les décimales a la fin s'arrêteront si il y a des 0 meme sans atteindre le nbDecimals - uniquement utilisé si nbDecimals est renseigné
   * @returns {string}
   */
  var buildPattern = function buildPattern(nbDecimals, suffix, optionalZeroAtTheEnd) {
    if (_.isNumber(nbDecimals)) {
      var optionalZeron = optionalZeroAtTheEnd === true && nbDecimals > 0;
      return "0,0." + (optionalZeron ? "[" : "") + stringUtils.repeatSequence("0", nbDecimals) + (optionalZeron ? "]" : "") + (suffix ? " " + suffix : "");
    } else {
      return "0,0.[00]" + (suffix ? " " + suffix : "");
    }
  };
  var defaultPlaceHolder = "-";
  var $numberFormat = function $numberFormat(number, patternOrDecimals, suffix, optionalZeroAtTheEnd, signed) {
    if (number == null) {
      return defaultPlaceHolder;
    }
    var isSigned = !_.isUndefined(signed);
    var pattern;
    if (_.isNumber(patternOrDecimals) || suffix) {
      pattern = buildPattern(patternOrDecimals, suffix, optionalZeroAtTheEnd);
    } else {
      pattern = patternOrDecimals || buildPattern();
    }
    try {
      var res = numeral(number).format(pattern);
      if (isSigned) {
        if (numeral(number) > 0) {
          res = "+" + res;
        }
      }
      return res;
    } catch (e) {
      console.log("Impossible de formater", number, pattern, e);
      return "ERR";
    }
  };
  _.extend($numberFormat, {
    /**
     * Returns the precision to use in formatters to catch "enough" significative digits of the given number
     *
     * @param value The value to compute a precision for
     */
    precisionSignificative: function precisionSignificative(value) {
      return value < 0.01 ? 5 : value < 0.01 ? 3 : 2;
    },
    /**
     * Returns a formatter function for given pattern.
     *
     * @param pattern The format to use for this formatter
     */
    formatter: function formatter(pattern) {
      return function (number) {
        return $numberFormat(number, pattern);
      };
    },
    /**
     *
     * @param {number} number
     * @param {number=} nbDecimals
     * @param {boolean} optionalZeroAtTheEnd - si nbDecimals renseigné, permet de rendre optionnel les décimales finales à 0
     * @returns {string} The formatter number.
     */
    number: function number(_number, nbDecimals, optionalZeroAtTheEnd) {
      return $numberFormat(_number, nbDecimals, undefined, optionalZeroAtTheEnd);
    },
    /**
     *
     * @param {number} number
     * @param {number=} nbDecimals
     * @returns {string} The formatted percentage.
     */
    currency: function currency(number, nbDecimals) {
      return $numberFormat(number, nbDecimals, "$");
    },
    /**
     *
     * @param {number} number (base 1)
     * @param {number=} nbDecimals
     * @returns {string} The formatted percentage : ex : 0.012 --> 0.12 %
     */
    percentage: function percentage(number, nbDecimals) {
      return $numberFormat(number, nbDecimals, "%");
    },
    /**
     *
     * @param {number} number
     * @param {number=} nbDecimals
     * @returns {string} The formatted bytes.
     */
    bytes: function bytes(number, nbDecimals) {
      var formatted = $numberFormat(number, nbDecimals, "b");
      // PGA : for now, numeral doesn't supports translation for bytes... doing it manually until then...
      var mapping = {
        "KB": "Ko",
        "MB": "Mo",
        "GB": "Go",
        "B": "o"
      };
      _.each(mapping, function (french, english) {
        formatted = formatted.replace(english, french);
      });
      return formatted;
    }
  });
  return $numberFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/number/numberFormat.js
// module id = 2733
// module chunks = 13